module.exports = __webpack_public_path__ + "static/media/35_tn.433a7d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/35_tn.jpg
// module id = 523
// module chunks = 0